export const getters = {
    getFabricante: state => state.fabricante,
    getFabricantes: state => state.fabricantes,
    getModalCadastroFabricante: state => state.modalCadastrarFabricante,
    getModalExcluirFabricante: state => state.modalExcluirFabricante,
    getModalPesquisarFabricante: state => state.modalPesquisarFabricante
}

export default {}